import { ReactComponent as NotificationIcon } from 'assets/icons/notification/notification.svg';

export const notification = {
  notification: NotificationIcon,
};
